// Generated by CoffeeScript 2.7.0
var Admin__Settings__TencentWecityController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsTencentWecity from 'trunks/vue/admin/components/settings/settings_container/settings_tencent_wecity.js';

export default Admin__Settings__TencentWecityController = (function() {
  class Admin__Settings__TencentWecityController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/tencent_wecity.json', {
        responseType: 'json',
        success: function(data) {
          return new SettingsTencentWecity({
            el: DomMaster.find("#js-settings-tencent_wecity").node,
            propsData: {
              activeTab: 'tencent_wecity',
              tencentWecity: data.tencent_wecity
            }
          });
        }
      });
    }

  };

  Admin__Settings__TencentWecityController.include(GenerateMorePopover);

  Admin__Settings__TencentWecityController.include(SettingsNavigator);

  return Admin__Settings__TencentWecityController;

}).call(this);
